<template>
  <div class="text-sm">
    <p class="mt-6"><b>2026.01.30</b> - Улучшения данных/кода/инфраструктуры</p>
    <ul class="ml-5 pb-4 list-outside list-disc text-cyan-300">
      <li>
        Рефакторинг данных забегов Пещеры, чтобы они не терялись при отключении сети или закрытии приложения.
      </li>
      <li>Исправлены утечки памяти/CPU в Пещеры и другие проблемы производительности.</li>
      <li>Бэкенд перенесён к новому облачному провайдеру с лучшей производительностью и автомасштабированием.</li>
    </ul>
  </div>
</template>
